import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("qa");

export const qaTransport = transport;
export const QA_BASE_URL = baseUrl;
